import { useState } from "react";
import API from "../services/api";
import "./addplan.css";

export default function AddPlan() {
  const [name, setName] = useState("silver");
  const [price, setPrice] = useState("");
  const [featuresText, setFeaturesText] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async () => {
    try {
      // Convert multiline text → array
      const featuresArray = featuresText
        .split("\n")
        .map((f) => f.trim())
        .filter((f) => f.length > 0);

      await API.post("/plans/create/", {
        name: name,
        price_per_student: price,
        features: featuresArray,   // ARRAY (✔ MATCHES MODEL)
      });

      setMessage("Plan created successfully!");
      setPrice("");
      setFeaturesText("");
    } catch (err) {
      console.log("ERROR:", err.response?.data);
      setMessage("Error creating plan");
    }
  };

  return (
    <div className="add-plan-container">
      <div className="add-plan-header">
        <span className="page-kicker">Plan Builder</span>
        <h2>Add New Plan</h2>
        <p>Set monthly per-student pricing and list the enabled school features.</p>
      </div>

      {message && <div className="alert-box">{message}</div>}

      <div className="form-card">
        {/* PLAN NAME */}
        <div className="form-group">
          <label>Plan Name</label>
          <select
            className="input"
            value={name}
            onChange={(e) => setName(e.target.value)}
          >
            <option value="silver">Silver</option>
            <option value="gold">Gold</option>
            <option value="platinum">Platinum</option>
          </select>
        </div>

        {/* PRICE */}
        <div className="form-group">
          <label>Price Per Student (Monthly)</label>
          <input
            className="input"
            type="text"
            placeholder="10.00"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </div>

        {/* FEATURES */}
        <div className="form-group">
          <label>Features (One per line)</label>
          <textarea
            className="textarea"
            placeholder={`Attendance\nHomework\nTransport Tracking\nFees Management`}
            value={featuresText}
            onChange={(e) => setFeaturesText(e.target.value)}
            rows={6}
          />
        </div>

        <button className="btn-primary" onClick={handleSubmit}>
          Create Plan
        </button>
      </div>
    </div>
  );
}
